import React from 'react';

export type NotificationType = 'success' | 'error' | 'info';

export interface Notification {
  id: string;
  message: string;
  type: NotificationType;
}

interface NotificationItemProps {
  notification: Notification;
  onDismiss: (id: string) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onDismiss }) => {
  let bgColor = 'bg-blue-500';
  if (notification.type === 'success') bgColor = 'bg-green-500';
  if (notification.type === 'error') bgColor = 'bg-red-500';

  return (
    <div 
      className={`max-w-sm w-full ${bgColor} text-white rounded-md shadow-lg mb-3 p-4 flex justify-between items-center transition-all duration-300 ease-in-out transform`}
      role="alert"
      aria-live={notification.type === 'error' ? 'assertive' : 'polite'}
    >
      <p className="text-sm">{notification.message}</p>
      <button
        onClick={() => onDismiss(notification.id)}
        className="ml-4 p-1 rounded-md hover:bg-white hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
        aria-label="알림 닫기"
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default NotificationItem;